/*
  RheasRaw: add-to-cart source tracking.

  Records where each item was added from (collection card, product page,
  upsell, search, ...) as the cart attribute `rr_atc_log`, which carries onto
  the order (admin only, never shown to customers). Format matches
  rr_upsell_log: "source:variantId;source:variantId".

  Sources:
    grid          collection page card "Add to cart" button
    grid_options  collection card "Choose options" pop-up
    home          homepage product rows
    search        search results cards
    pdp           product page main Add to cart
    pdp_recs      product cards shown on a product page (you may also like)
    pairs         Pairs well with / complementary products
    calculator    feeding calculator on a product page
                  (calculator_collection etc. elsewhere)
    cart_upsell   basket "Add to your order" pairing (cart-upsell.js)
    cart_treat    basket "Add to your order" treat
    cart_chew     basket "Add to your order" chew
    xmas_upsell   basket "Add to your order" Christmas pick
    popup_upsell  "Goes well with" in the add-to-cart pop-up (rr-atc-upsell.js)
    usuals        "Your usuals" card Add (rr-usuals.js)
    usuals_swap   "Your usuals" swap suggestion for an out-of-stock usual
    usuals_all    "Your usuals" Add all in stock
    usuals_new    "Your usuals" Try something new card
    usuals_reorder       "Your last order" reorder (in-stock lines)
    usuals_reorder_swap  "Your last order" swap ticked for a sold-out line
    soldout_swap  "Sold out today, try this instead" on a product page
    first_week    "Your dog's first week of raw" bundle (sections/rr-first-week.liquid)
    search_live   Add button in the live search results under the search box
    cart_recs     product cards shown on the cart page
    other_<page>  anything else, with the Shopify page type

  Guides: a click from a guide page (/pages/...) through to a product or
  collection is remembered on the device for 7 days. When that visitor adds
  to the basket, the cart attribute `rr_guide` lists the clicks as
  "guide>target;guide>target" (e.g. "tripe-for-dogs>collections/tripe"), so
  the order shows which guide led there. Each click is also published as the
  customer event `rr_guide_click` for the GA4 custom pixel.

  It watches clicks to remember the context, then watches successful
  /cart/add requests (jQuery/XHR and fetch) to log the variants that were
  actually added. Everything is best effort and never blocks the basket.
*/
(function () {
  if (window.__rrAtcSource) return;
  window.__rrAtcSource = true;

  var ATTR = 'rr_atc_log';
  var GUIDE_ATTR = 'rr_guide';
  var GUIDE_KEY = 'rr_guide_trail';
  var GUIDE_DAYS = 7;
  var GUIDE_MAX = 5;
  var GUIDE_SKIP = ['contact', 'contact-us'];
  var MAX_LEN = 1000;
  var PENDING_MS = 20000;
  var pageType = (window.ShopifyAnalytics && window.ShopifyAnalytics.meta && window.ShopifyAnalytics.meta.page && window.ShopifyAnalytics.meta.page.pageType) || '';
  if (!pageType) {
    var m = (document.body && document.body.className || '').match(/template-([a-z_]+)/);
    pageType = m ? m[1] : 'unknown';
  }

  function publish(name, data) {
    try {
      if (window.Shopify && window.Shopify.analytics && typeof window.Shopify.analytics.publish === 'function') {
        window.Shopify.analytics.publish(name, data);
      }
    } catch (e) { /* analytics is best effort */ }
  }

  // Guide clicks, kept in localStorage so a purchase a few days later still counts.
  var guideMatch = location.pathname.match(/^\/pages\/([^\/?#]+)/);
  var guideHandle = guideMatch && GUIDE_SKIP.indexOf(guideMatch[1]) === -1 ? guideMatch[1] : '';

  function readGuideTrail() {
    try {
      var list = JSON.parse(localStorage.getItem(GUIDE_KEY) || '[]');
      var cutoff = Date.now() - GUIDE_DAYS * 864e5;
      return Array.isArray(list) ? list.filter(function (i) { return i && i.at > cutoff; }) : [];
    } catch (e) { return []; }
  }

  function rememberGuideClick(target) {
    var list = readGuideTrail().filter(function (i) { return !(i.g === guideHandle && i.t === target); });
    list.push({ g: guideHandle, t: target, at: Date.now() });
    while (list.length > GUIDE_MAX) list.shift();
    try { localStorage.setItem(GUIDE_KEY, JSON.stringify(list)); } catch (e) { /* storage blocked */ }
  }

  if (guideHandle) {
    document.addEventListener('click', function (evt) {
      var link = evt.target && evt.target.closest && evt.target.closest('#site-main a[href]');
      if (!link) return;
      var url;
      try { url = new URL(link.getAttribute('href'), location.href); } catch (e) { return; }
      if (url.hostname.replace(/^www\./, '') !== location.hostname.replace(/^www\./, '')) return;
      var path = url.pathname.match(/^\/((?:products|collections)\/[^\/?#]+(?:\/products\/[^\/?#]+)?)/);
      if (!path) return;
      rememberGuideClick(path[1]);
      publish('rr_guide_click', { guide: guideHandle, target: path[1] });
    }, true);
  }

  var pending = null; // { source, at }

  function setPending(source) {
    pending = { source: source, at: Date.now() };
  }
  // Lets RheasRaw scripts that add several items one after another (rr-usuals.js) keep their source.
  window.rrAtcSetSource = setPending;

  function takePending() {
    var p = pending;
    if (p && Date.now() - p.at < PENDING_MS) return p.source;
    return 'other_' + pageType;
  }

  function hasWord(el, re) {
    var id = el.id || '';
    var cls = typeof el.className === 'string' ? el.className : '';
    var sec = el.getAttribute && (el.getAttribute('data-section-type') || '');
    return re.test(id) || re.test(cls) || re.test(sec);
  }

  function ancestorMatches(el, re) {
    for (var n = el; n && n !== document.body; n = n.parentElement) {
      if (hasWord(n, re)) return true;
    }
    return false;
  }

  function sourceFor(el) {
    if (el.closest('[data-rr-usuals]')) {
      if (el.closest('[data-rr-reorder]')) return 'usuals_reorder';
      if (el.closest('[data-rr-usuals-all]')) return 'usuals_all';
      if (el.closest('[data-rr-usuals-swap]')) return 'usuals_swap';
      if (el.closest('[data-rr-usuals-new]')) return 'usuals_new';
      return 'usuals';
    }
    if (el.closest('[data-rr-first-week]')) return 'first_week';
    if (el.closest('[data-rr-soldout-swap]')) return 'soldout_swap';
    if (el.closest('[data-rr-search-add]')) return 'search_live';
    var upsellCard = el.closest('[data-cart-upsell-item]');
    if (upsellCard) {
      var cardSource = upsellCard.getAttribute('data-rr-source');
      if (cardSource === 'cart_treat' || cardSource === 'cart_chew' || cardSource === 'xmas_upsell') return cardSource;
    }
    if (el.closest('[data-cart-upsell]')) return 'cart_upsell';
    if (el.closest('[data-rr-atc-upsell]')) return 'popup_upsell';
    if (ancestorMatches(el, /calculator/i)) return pageType === 'product' ? 'calculator' : 'calculator_' + pageType;
    if (ancestorMatches(el, /pairs|complementary/i)) return 'pairs';

    if (el.closest('[data-quickshop-slim]')) return 'grid_options';
    if (el.closest('[data-modal-container], [data-modal-container-1]')) {
      // Add button inside the options pop-up keeps the source set when it opened.
      return pending && Date.now() - pending.at < PENDING_MS ? pending.source : 'grid_options';
    }

    if (el.closest('[data-product-item]')) {
      if (pageType === 'collection') return 'grid';
      if (pageType === 'home' || pageType === 'index') return 'home';
      if (pageType === 'searchresults' || pageType === 'search') return 'search';
      if (pageType === 'product') return 'pdp_recs';
      if (pageType === 'cart') return 'cart_recs';
      return 'grid_' + pageType;
    }

    if (pageType === 'product' && el.closest('form[action*="/cart/add"], product-form, [data-product-form], .product-form')) return 'pdp';
    return null;
  }

  document.addEventListener('click', function (evt) {
    var target = evt.target;
    if (!target || !target.closest) return;
    var button = target.closest('button, [type="submit"], a, label, [role="button"]');
    if (!button) return;
    var source = sourceFor(button);
    if (source) setPending(source);
  }, true);

  // Product page forms submitted with the keyboard.
  document.addEventListener('submit', function (evt) {
    var form = evt.target;
    if (form && form.action && form.action.indexOf('/cart/add') !== -1) {
      var source = sourceFor(form);
      if (source) setPending(source);
    }
  }, true);

  function isCartAdd(url) {
    return typeof url === 'string' && /\/cart\/add(\.js)?(\?|$)/.test(url.replace(location.origin, ''));
  }

  function variantIdsFrom(data) {
    if (!data) return [];
    if (data.items && data.items.length) {
      return data.items.map(function (i) { return i.variant_id || i.id; }).filter(Boolean);
    }
    return data.variant_id ? [data.variant_id] : [];
  }

  var queue = Promise.resolve();
  // Lets a script that leaves the page straight after adding (the reorder) wait for the log to save.
  // The short pause lets the add's response reach onAdded first.
  window.rrAtcFlush = function () {
    return new Promise(function (resolve) { setTimeout(resolve, 200); }).then(function () { return queue; });
  };

  function record(source, variantIds) {
    if (!variantIds.length) return;
    publish('rr_add_to_cart', { source: source, variantIds: variantIds.join(','), pageType: pageType });

    // Serialise writes so quick taps on several cards don't overwrite each other.
    queue = queue.then(function () {
      return origFetch('/cart.js', { credentials: 'same-origin' })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          var current = cart.attributes && cart.attributes[ATTR] ? String(cart.attributes[ATTR]) : '';
          var log = current ? current.split(';') : [];
          variantIds.forEach(function (id) {
            var entry = source + ':' + id;
            if (log.indexOf(entry) === -1) log.push(entry);
          });
          while (log.join(';').length > MAX_LEN) log.shift();
          var attrs = {};
          attrs[ATTR] = log.join(';');

          var guides = readGuideTrail().map(function (i) { return i.g + '>' + i.t; });
          if (guides.length) {
            var currentGuides = cart.attributes && cart.attributes[GUIDE_ATTR] ? String(cart.attributes[GUIDE_ATTR]).split(';') : [];
            guides.forEach(function (g) { if (currentGuides.indexOf(g) === -1) currentGuides.push(g); });
            while (currentGuides.join(';').length > MAX_LEN) currentGuides.shift();
            attrs[GUIDE_ATTR] = currentGuides.join(';');
          }

          return origFetch('/cart/update.js', {
            method: 'POST',
            credentials: 'same-origin',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ attributes: attrs })
          });
        });
    }).catch(function () { /* never let tagging affect the basket */ });
  }

  function onAdded(responseText) {
    var data;
    try { data = JSON.parse(responseText); } catch (e) { return; }
    if (!data || data.status) return; // error payloads carry a status code
    var source = takePending();
    pending = null;
    record(source, variantIdsFrom(data));
  }

  // fetch (cart upsell, product page sections, newer components)
  var origFetch = window.fetch.bind(window);
  window.fetch = function (input, init) {
    var url = typeof input === 'string' ? input : (input && input.url) || '';
    var method = (init && init.method) || (input && input.method) || 'GET';
    var p = origFetch(input, init);
    if (String(method).toUpperCase() === 'POST' && isCartAdd(url)) {
      p.then(function (res) {
        if (res && res.ok) res.clone().text().then(onAdded).catch(function () {});
      }).catch(function () {});
    }
    return p;
  };

  // XMLHttpRequest (Empire's jQuery add-to-cart for grid cards and the product form)
  var origOpen = XMLHttpRequest.prototype.open;
  var origSend = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.open = function (method, url) {
    this.__rrAtc = String(method).toUpperCase() === 'POST' && isCartAdd(String(url));
    return origOpen.apply(this, arguments);
  };
  XMLHttpRequest.prototype.send = function () {
    if (this.__rrAtc) {
      var xhr = this;
      xhr.addEventListener('load', function () {
        if (xhr.status >= 200 && xhr.status < 300) onAdded(xhr.responseText);
      });
    }
    return origSend.apply(this, arguments);
  };

  // Sold-out product pages (lost demand). snippets/rr-soldout-swap.liquid leaves a hidden
  // marker when every size of the product is sold out. Published as rr_soldout_view.
  function soldoutView() {
    var el = document.querySelector('[data-rr-soldout-view]');
    if (!el) return;
    publish('rr_soldout_view', {
      product: el.getAttribute('data-product') || '',
      title: el.getAttribute('data-title') || '',
      productType: el.getAttribute('data-type') || ''
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', soldoutView);
  else soldoutView();

  // Local actions: taps on phone, email and directions/map links anywhere on the site.
  // Published as rr_contact_click { kind: phone | email | directions, page }.
  document.addEventListener('click', function (evt) {
    var link = evt.target && evt.target.closest && evt.target.closest('a[href]');
    if (!link) return;
    var href = link.getAttribute('href') || '';
    var kind = '';
    if (/^tel:/i.test(href)) kind = 'phone';
    else if (/^mailto:/i.test(href)) kind = 'email';
    else if (/google\.[a-z.]+\/maps|maps\.google\.|maps\.app\.goo\.gl|goo\.gl\/maps|maps\.apple\.com/i.test(href)) kind = 'directions';
    if (!kind) return;
    publish('rr_contact_click', { kind: kind, page: location.pathname.slice(0, 100) });
  }, true);
}());
